import { render, staticRenderFns } from "./TrafficMessageConsequenceText.vue?vue&type=template&id=342fc9bc"
import script from "./TrafficMessageConsequenceText.vue?vue&type=script&lang=js"
export * from "./TrafficMessageConsequenceText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports